"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _actions2 = require("egov-ui-kit/redux/form/actions");

var formConfig = {
  name: "buildingDetails",
  fields: {
    buildingType: {
      id: "buildingType",
      jsonPath: "Properties[0].buildingDetails.buildingType",
      type: "singleValueList",
      floatingLabelText: "Building Type",
      fullWidth: true,
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        dispatch((0, _actions2.setFieldProperty)("propertyAddress", "buildingType", "value", field.value));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].buildingDetails.buildingType", field.value));
      }
    },
    numberOfStories: {
      id: "numberOfStories",
      jsonPath: "Properties[0].buildingDetails.numberOfStories",
      type: "textfield",
      floatingLabelText: "Number of Stories",
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        dispatch((0, _actions2.setFieldProperty)("propertyAddress", "numberOfStories", "value", field.value));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].buildingDetails.numberOfStories", field.value));
      }
    },
    occupancyStatus: {
      id: "occupancyStatus",
      type: "singleValueList",
      floatingLabelText: "Occupancy Status",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },
      jsonPath: "Properties[0].buildingDetails.occupancyStatus",
      updateDependentFields: function updateDependentFields(_ref3) {
        var formKey = _ref3.formKey,
            field = _ref3.field,
            dispatch = _ref3.dispatch,
            state = _ref3.state;

        dispatch((0, _actions2.setFieldProperty)("propertyAddress", "occupancyStatus", "value", field.value));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].buildingDetails.occupancyStatus", field.value));
      }
    },
    plotArea: {
      id: "plotArea",
      type: "textfield",
      floatingLabelText: "Plot Area",
      jsonPath: "Properties[0].buildingDetails.plotArea",
      updateDependentFields: function updateDependentFields(_ref4) {
        var formKey = _ref4.formKey,
            field = _ref4.field,
            dispatch = _ref4.dispatch,
            state = _ref4.state;

        dispatch((0, _actions2.setFieldProperty)("propertyAddress", "plotArea", "value", field.value));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].buildingDetails.plotArea", field.value));
      }
    },
    coveredArea: {
      id: "coveredArea",
      type: "textfield",
      floatingLabelText: "Covered Area",
      jsonPath: "Properties[0].buildingDetails.coveredArea",
      updateDependentFields: function updateDependentFields(_ref5) {
        var formKey = _ref5.formKey,
            field = _ref5.field,
            dispatch = _ref5.dispatch,
            state = _ref5.state;

        dispatch((0, _actions2.setFieldProperty)("propertyAddress", "coveredArea", "value", field.value));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].buildingDetails.coveredArea", field.value));
      }
    },
    parkingArea: {
      id: "parkingArea",
      type: "textfield",
      floatingLabelText: "Parking Area",
      jsonPath: "Properties[0].buildingDetails.parkingArea",
      updateDependentFields: function updateDependentFields(_ref6) {
        var formKey = _ref6.formKey,
            field = _ref6.field,
            dispatch = _ref6.dispatch,
            state = _ref6.state;

        dispatch((0, _actions2.setFieldProperty)("propertyAddress", "parkingArea", "value", field.value));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].buildingDetails.parkingArea", field.value));
      }
    },
    commonArea: {
      id: "commonArea",
      jsonPath: "Properties[0].buildingDetails.commonArea",
      type: "textfield",
      floatingLabelText: "Common Area",
      hintText: "",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "required!",
      updateDependentFields: function updateDependentFields(_ref7) {
        var formKey = _ref7.formKey,
            field = _ref7.field,
            dispatch = _ref7.dispatch,
            state = _ref7.state;

        dispatch((0, _actions2.setFieldProperty)("propertyAddress", "commonArea", "value", field.value));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].buildingDetails.commonArea", field.value));
      }
    }
  },

  afterInitForm: function afterInitForm(action, store, dispatch) {
    var occupancyStatusTypeDropDownData = [{
      name: "Self",
      code: "Self",
      label: "Self",
      value: "Self"
    }, {
      name: "Part Self Part Tenant",
      code: "Part Self Part Tenant",
      label: "Part Self Part Tenant",
      value: "Part Self Part Tenant"
    }, {
      name: "Full Tenant",
      code: "Full Tenant",
      label: "Full Tenant",
      value: "Full Tenant"
    }, {
      name: "Part Self Part Commercial",
      code: "Part Self Part Commercial",
      label: "Part Self Part Commercial",
      value: "Part Self Part Commercial"
    }, {
      name: "Full Commercial",
      code: "Full Commercial",
      label: "Full Commercial",
      value: "Full Commercial"
    }];

    var buildingTypeDropDownData = [{
      name: "Kancha",
      code: "Kancha",
      label: "Kancha",
      value: "Kancha"
    }, {
      name: "Pucca",
      code: "Pucca",
      label: "Pucca",
      value: "Pucca"
    }, {
      name: "Flat",
      code: "Flat",
      label: "Flat",
      value: "Flat"
    }, {
      name: "Semi Pucca",
      code: "Semi Pucca",
      label: "Semi Pucca",
      value: "Semi Pucca"
    }];
    dispatch((0, _actions2.setFieldProperty)("buildingDetails", "buildingType", "dropDownData", buildingTypeDropDownData));
    dispatch((0, _actions2.setFieldProperty)("buildingDetails", "occupancyStatus", "dropDownData", occupancyStatusTypeDropDownData));
    return action;
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPay/buildingDetails.js
// module id = 1679
// module chunks = 1137